import "./App.css";
import { Route, Routes } from "react-router-dom";
import AOS from "aos";
import "aos/dist/aos.css";
import Router from "./Routes/routes";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import './variable.css';
import useStore from './Store';

AOS.init();

function App() {
  const { Theme } = useStore();
  const className = Theme === 'default' ? '' : 'green';
  return (
    <div className={className} style={{ zoom: 0.9 }} >
      <Routes>
        <Route path="*" element={<Router />} />
      </Routes>
    </div>
  );
}

export default App;
